import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {SelectVnaCampaignComponent} from '../select-vna-campaign/select-vna-campaign.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {VnaCampaignSelected} from '../../model/vna_campaign_selected';

import * as _ from 'underscore';

const SELECT_MULTIPLE_VNA_CAMPAIGN_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaCampaignMultipleComponent)
};

@Component({
    selector: 'app-select-vna-campaign-multiple',
    template: `
      <ng-multiselect-dropdown [data]="campaigns" [(ngModel)]="camps" (onSelect)="selected($event)" (onSelectAll)="selected($event)" [placeholder]="textDefault" [settings]="settings" >
      </ng-multiselect-dropdown>
      `,
    styleUrls: ['./select-vna-campaign-multiple.component.scss'],
    providers: [SELECT_MULTIPLE_VNA_CAMPAIGN_VALUE_ACCESSOR]
})
export class SelectVnaCampaignMultipleComponent implements OnInit, ControlValueAccessor{

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';
    @Input() textDefault: string = 'Select campaigns';

    campaigns: Array<Object> = [];
    _camps: any;

    settings: Object;

    constructor(private campHandler: VnaCampaignService, private messaging: MessagingService, private auth: AuthService) {

        this.settings = {
            singleSelection: false,
            idField: this.valueField,
            textField: this.textField,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 10,
            allowSearchFilter: true
        }
    }

    ngOnInit() {
        this.campHandler.findPortalCampaigns(this.auth.getPkPortal()).subscribe(
            (result) => {
                this.campaigns = result;
                if(_.isArray(this._camps)){
                  const camps = this._camps.map( (e: any) => {
                    if(!_.isObject(e)){
                      let c = this.campaigns.filter( (o: any) => { return o.pk === e });
                      return c[0];
                    }
                    return e;
                  });
                  this.writeValue(camps);
                }
            }
        );

        this.messaging.message.subscribe(
            (value) => {
                if(value instanceof VnaPortalSelected && !value.isTheFirst()){
                    this.campHandler.findPortalCampaigns(value.getPkPortal()).subscribe(
                        (result) => {
                            this.campaigns = result;
                        }
                    )
                }
            }
        )

    }


    selected(value: any) {
        this.messaging.sendMessage(new VnaCampaignSelected(value[this.valueField]));
        this.propagateChange(this._camps);
    }


    get camps(): any { return this._camps; };

    set camps(v: any) {
        this._camps = v;
        this.propagateChange(this._camps);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._camps = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/select-vna-campaign-multiple/select-vna-campaign-multiple.component.ts